import { Country, LocaleToCountry } from '@ddt-web/domain';

/**
 * In the following class: 
 * Country = en_CH
 *  Locale = en-ch
 */
export class LocaleUtil {

	/**
	 * Retrieves the country from value.
	 * @param expression Can be CH, ch, en_CH
	 * @returns Finds the country string equivalent (ch, gb etc)
	 */
	public static getCountryStringFromLocaleExpr(expression: string): string {
		const country: Country = this.getCountryFromExpr(expression);
		const locale: string = Object.entries(LocaleToCountry)
			.find(([, countryItem]) => country === countryItem)?.[0];

		if (!locale) {
			return null;
		}

		const [, countryString] = locale.split('-');
		return countryString;
	}

	/**
	 * Retrieves the country from value.
	 * @param expression Can be CH, ch, en_CH
	 * @returns Finds the Country equivalent
	 */
	public static getCountryFromExpr(expression: string): Country {
		if (!expression) {
			return null;
		}

		expression = expression.toLowerCase();

		let country = expression;
		if (expression.includes('-')) {
			[, country] = expression.split('-');
		} else if (expression.includes('_')) {
			[, country] = expression.split('_');
		}

		for (const [localeItem, countryItem] of Object.entries(LocaleToCountry)) {
			if (localeItem.endsWith('-' + country)) {
				return Country[countryItem];
			}
		}

		return null;
	}

	/**
	 * Retrieves the locale from country.
	 * @param expression Can be CH, ch, en_CH
	 * @returns Finds the locale equivalent (en-ch, en-gb etc)
	 */
	public static getLocaleFromExpr(expression: string): string {
		if (!expression) {
			return null;
		}

		expression = expression.toLowerCase();

		let country = expression;
		if (expression.includes('-')) {
			[, country] = expression.split('-');
		} else if (expression.includes('_')) {
			[, country] = expression.split('_');
		}

		for (const [localeItem] of Object.entries(LocaleToCountry)) {
			if (localeItem.endsWith('-' + country)) {
				return localeItem;
			}
		}

		return null;
	}

	/**
	 * Retrieve locale string from country
	 * @param country 
	 * @returns en-ch or en-at depending on the country input
	 */
	public static getLocaleFromCountry(country: Country): string {
		if (!country) {
			return null;
		}

		for (const [localeItem, countryItem] of Object.entries(LocaleToCountry)) {
			if (country === countryItem) {
				return localeItem;
			}
		}

		return null;
	}

}
